// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * THE CARD WEARS THE PORTAL'S PALETTE, NOT THE LIBRARY'S.
 *
 * Every rule is scoped to \`.aksel-expansioncard\`, so nothing reaches the rest
 * of the app. All fifteen tokens the library's stylesheet reads are listed —
 * in full rather than guessed at — and each is pointed at the portal token
 * that already answers the same question.
 */
.aksel-expansioncard {
  /* The card itself, and the header's hover. \`bg-soft\` is the base rule and
     \`bg-raised\` the one that wins at the default neutral colour; both are set
     so the card cannot change colour if that default ever moves. */
  --ax-bg-raised: var(--color-surface);
  --ax-bg-soft: var(--color-surface);
  --ax-bg-moderate-hover: var(--color-surface-sunken-hover);
  /* The card's own edge, the ring it grows on hover, and the hairline that
     separates an open header from its content. */
  --ax-border-default: var(--color-border);
  --ax-border-strong: var(--color-border-hover);
  --ax-border-subtle: var(--color-border);
  --ax-border-focus: var(--color-accent);
  /* The card's corner, and the chevron button's. */
  --ax-radius-12: var(--radius-section);
  --ax-radius-8: var(--radius-md);
}

/*
 * THE HEADER IS A LID, NOT A HEADING.
 *
 * Closed, it reads as the portal's other section triggers do: the label muted
 * so the open one stands out against it. The library styles it as a card
 * heading — full ink at 20px — which made four closed sections shout at a
 * reader who had opened none of them.
 */
.aksel-expansioncard .aksel-expansioncard__title {
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--color-text-muted);
  /* On desktop the label keeps its width; mobile overrides follow below. A section
     reading «Hvem som skal…» on two lines is both taller than its neighbours
     and worse at saying what is behind it; a clipped summary still leaves the
     section usable. So the label takes what it needs and the summary clips. */
  white-space: nowrap;
  flex-shrink: 0;
  /* ⛔ The library nudges the title down to sit optically beside a 3rem
     chevron. This header centres its own row, so the nudge only knocks the
     label off the centre line. */
  margin-top: 0;
}

.aksel-expansioncard__header[data-open='true'] .aksel-expansioncard__title,
.aksel-expansioncard__header:hover .aksel-expansioncard__title {
  color: var(--color-text);
}

/*
 * Desktop headers keep the same height (G2).
 *
 * The row centres its content so the label sits on the chevron's centre line,
 * and the height then comes from the chevron alone — 2rem plus the small
 * size's block padding. A summary rides the same line and never adds to it.
 */
.aksel-expansioncard__header {
  align-items: center;
}

/*
 * THE HEADER ROW MUST BE ALLOWED TO SHRINK.
 *
 * The library wraps the header's content in a \`div\` of its own that this
 * component cannot reach from JSX — and a flex child defaults to \`min-width:
 * auto\`, which means "never smaller than my content". So a long summary pushed
 * the row wider than the card instead of clipping, and slid under the chevron.
 * Nothing else in here can fix it: the clip has to be allowed at the level that
 * owns the width.
 */
.aksel-expansioncard__header > div:first-child {
  min-width: 0;
  flex: 1 1 auto;
}

.aksel-expansioncard__header-button {
  /* ⛔ The library pins the chevron to the top of the header for its two-line
     Description layout. There is no second line here. */
  align-self: center;
}

/* Match the portal's mobile breakpoint. Desktop geometry stays unchanged. */
@media (max-width: 767px) {
  .aksel-expansioncard .section-card-heading {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .aksel-expansioncard .aksel-expansioncard__title,
  .aksel-expansioncard .section-card-summary {
    white-space: normal;
    overflow-wrap: anywhere;
    max-width: 100%;
  }

  .aksel-expansioncard .section-card-summary {
    overflow: visible;
    text-overflow: clip;
  }
}
`, "",{"version":3,"sources":["webpack://./src/flyt/ui/SectionCard/SectionCard.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;EACE;;mEAEiE;EACjE,oCAAoC;EACpC,kCAAkC;EAClC,yDAAyD;EACzD;iDAC+C;EAC/C,wCAAwC;EACxC,6CAA6C;EAC7C,uCAAuC;EACvC,sCAAsC;EACtC,iDAAiD;EACjD,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;;;;;;;EAOE;AACF;EACE,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B;;;8EAG4E;EAC5E,mBAAmB;EACnB,cAAc;EACd;;iCAE+B;EAC/B,aAAa;AACf;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;;EAME;AACF;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE;AACF;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;wDACsD;EACtD,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;;IAEE,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * THE CARD WEARS THE PORTAL'S PALETTE, NOT THE LIBRARY'S.\n *\n * Every rule is scoped to `.aksel-expansioncard`, so nothing reaches the rest\n * of the app. All fifteen tokens the library's stylesheet reads are listed —\n * in full rather than guessed at — and each is pointed at the portal token\n * that already answers the same question.\n */\n.aksel-expansioncard {\n  /* The card itself, and the header's hover. `bg-soft` is the base rule and\n     `bg-raised` the one that wins at the default neutral colour; both are set\n     so the card cannot change colour if that default ever moves. */\n  --ax-bg-raised: var(--color-surface);\n  --ax-bg-soft: var(--color-surface);\n  --ax-bg-moderate-hover: var(--color-surface-sunken-hover);\n  /* The card's own edge, the ring it grows on hover, and the hairline that\n     separates an open header from its content. */\n  --ax-border-default: var(--color-border);\n  --ax-border-strong: var(--color-border-hover);\n  --ax-border-subtle: var(--color-border);\n  --ax-border-focus: var(--color-accent);\n  /* The card's corner, and the chevron button's. */\n  --ax-radius-12: var(--radius-section);\n  --ax-radius-8: var(--radius-md);\n}\n\n/*\n * THE HEADER IS A LID, NOT A HEADING.\n *\n * Closed, it reads as the portal's other section triggers do: the label muted\n * so the open one stands out against it. The library styles it as a card\n * heading — full ink at 20px — which made four closed sections shout at a\n * reader who had opened none of them.\n */\n.aksel-expansioncard .aksel-expansioncard__title {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: var(--color-text-muted);\n  /* On desktop the label keeps its width; mobile overrides follow below. A section\n     reading «Hvem som skal…» on two lines is both taller than its neighbours\n     and worse at saying what is behind it; a clipped summary still leaves the\n     section usable. So the label takes what it needs and the summary clips. */\n  white-space: nowrap;\n  flex-shrink: 0;\n  /* ⛔ The library nudges the title down to sit optically beside a 3rem\n     chevron. This header centres its own row, so the nudge only knocks the\n     label off the centre line. */\n  margin-top: 0;\n}\n\n.aksel-expansioncard__header[data-open='true'] .aksel-expansioncard__title,\n.aksel-expansioncard__header:hover .aksel-expansioncard__title {\n  color: var(--color-text);\n}\n\n/*\n * Desktop headers keep the same height (G2).\n *\n * The row centres its content so the label sits on the chevron's centre line,\n * and the height then comes from the chevron alone — 2rem plus the small\n * size's block padding. A summary rides the same line and never adds to it.\n */\n.aksel-expansioncard__header {\n  align-items: center;\n}\n\n/*\n * THE HEADER ROW MUST BE ALLOWED TO SHRINK.\n *\n * The library wraps the header's content in a `div` of its own that this\n * component cannot reach from JSX — and a flex child defaults to `min-width:\n * auto`, which means \"never smaller than my content\". So a long summary pushed\n * the row wider than the card instead of clipping, and slid under the chevron.\n * Nothing else in here can fix it: the clip has to be allowed at the level that\n * owns the width.\n */\n.aksel-expansioncard__header > div:first-child {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.aksel-expansioncard__header-button {\n  /* ⛔ The library pins the chevron to the top of the header for its two-line\n     Description layout. There is no second line here. */\n  align-self: center;\n}\n\n/* Match the portal's mobile breakpoint. Desktop geometry stays unchanged. */\n@media (max-width: 767px) {\n  .aksel-expansioncard .section-card-heading {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .aksel-expansioncard .aksel-expansioncard__title,\n  .aksel-expansioncard .section-card-summary {\n    white-space: normal;\n    overflow-wrap: anywhere;\n    max-width: 100%;\n  }\n\n  .aksel-expansioncard .section-card-summary {\n    overflow: visible;\n    text-overflow: clip;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
